import { render, staticRenderFns } from "./PaymentResult.vue?vue&type=template&id=0a5dc7e5&scoped=true"
import script from "./PaymentResult.vue?vue&type=script&lang=ts"
export * from "./PaymentResult.vue?vue&type=script&lang=ts"
import style0 from "./PaymentResult.vue?vue&type=style&index=0&id=0a5dc7e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5dc7e5",
  null
  
)

export default component.exports